export default {
  informationSectionCreditCardTitle: {
    id: 'express_replacement_details_information_section_credit_card_title',
    defaultMessage: 'Confirm your credit card',
  },
  informationSectionCreditCardDescription: {
    id: 'express_replacement_details_information_section_credit_card_description',
    defaultMessage:
      "You'll only be charged if you don't return your original device.",
  },
  informationSectionDeliveryDateTitle: {
    id: 'express_replacement_details_information_section_delivery_date_title',
    defaultMessage: 'Get your replacement device between {min} - {max}',
  },
  informationSectionDeliveryDateDescription: {
    id: 'express_replacement_details_information_section_delivery_date_description',
    defaultMessage:
      'Free shipping. Transfer potential data to your new replacement device.',
  },
  informationSectionReturnDeadlineTitle: {
    id: 'express_replacement_details_information_section_return_deadline_title',
    defaultMessage: 'Return the original by {deadline}',
  },
  informationSectionReturnDeadlineDescription: {
    id: 'express_replacement_details_information_section_return_deadline_description',
    defaultMessage:
      'The hold on your credit card is lifted once seller has received and approved the original device.',
  },
  informationSectionAllDoneTitle: {
    id: 'express_replacement_details_information_section_all_done_title',
    defaultMessage: 'All done',
  },
  informationSectionAllDoneDescription: {
    id: 'express_replacement_details_information_section_all_done_description',
    defaultMessage: 'Nothing left to be done, enjoy your new device!',
  },
}
